import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { usePageTitle, useScrollToTop } from "../hooks";
import { ArticleDetailsContent, ArticleDetailsHeader } from "../components/commons";

const ArticleDetails = () => {
    useScrollToTop();
    usePageTitle('Détails article');
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // Enregistre la page d'origine si elle est disponible dans l'état de navigation
        let from = location.state?.from || '/';

        // Fonction pour gérer le bouton retour du navigateur
        const handleBackButton = (e) => {
            // Empêche le comportement par défaut
            e.preventDefault();

            // Rediriger vers la page précédente
            navigate(from, { replace: true });
        };

        // Ajoute un écouteur pour l'événement popstate (bouton retour)
        window.addEventListener('popstate', handleBackButton);

        // Nettoyage lors du démontage du composant
        return () => {
            window.removeEventListener('popstate', handleBackButton);
        };
    }, [navigate, location]);

    return (
        <div>
            <ArticleDetailsHeader />
            <ArticleDetailsContent />
        </div>
    );
};

export default ArticleDetails;

// TODO - Atlas Frontoffice

// correction getAllAffiliation - soummission article - Maminiaina - Waiting
// place document annexe après contenue - détails article - OK
// champ ORCID de l'auteur - soumission article - Maminiaina - OK
// safidy langue avec langue paramétré dans l'api détails article - détails article - Maminiaina - Waiting
// affichage des documents annexes trier par type de fichiers (pdf, word, image) dans un carousel responsive - détails article - ok
// amélioration des citer et auteur selon pdf - détails article - ok
// id_link au lieu de slug pour liens vers détails articles - onclick sur les articles - Maminiaina